
import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import config from 'config/default.json';

@Component({
  selector: 'app-vcl-ressource-manager',
  templateUrl: './vcl-ressource-manager.component.html',
  styleUrls: ['./vcl-ressource-manager.component.scss']
})
export class VclRessourceManagerComponent {
constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {}
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  filterData:any = [];
  contentData:{[x: string]: any}[] = [];
  elementData:{[x: string]: any}[] = [];
  metaData:{[x: string]: any} = new Map();
  modes:{ [x:string]: string|number }[] = [{id: 'structure', value: 'Structure'}, {id: 'department', value: 'Department'}, {id: 'vca_module', value: 'Module'}, {id: 'vcl-manage-con', value: 'Content'}];
  pageId = 'vcl-manage-ressource'
  manageKey = 'vcl-manage-con';
  
  ngOnInit(): void { }

  setProgress(data:any){

  }
  sendFilterData(data:any){
    this.inProgress.emit(true);
    this.manageKey = data.mode;
    this.filterData = data;
  }
}
